import requestStatuses from '@clearscore/constants.request-statuses';
import { getSessionCookie } from '@clearscore/helpers.cookies';
import { PROFILE_STATUSES, ACCOUNT_STATUSES } from '@clearscore/constants.profile-statuses';
import roles from '@clearscore/constants.role-statuses';
import { types as profileTypes } from '@clearscore/redux.profile';
import types from '@clearscore/constants.session-action-types';

/**
 * List of all statuses for userRole AUTHORISED
 */
export const AUTHED_IDV_STATUSES = [PROFILE_STATUSES.PASS, PROFILE_STATUSES.THIN_FILE, PROFILE_STATUSES.NO_FILE];

const getProfileFetchSuccessRole = (payload) => {
    const { accountIDVStatus, failureReason, userStatus } = payload || {};

    if (AUTHED_IDV_STATUSES.includes(accountIDVStatus) && !failureReason && userStatus === ACCOUNT_STATUSES.ACTIVE) {
        return roles.AUTHORISED;
    }

    return roles.PROSPECT;
};

const sessionToken = getSessionCookie();

// @todo: This conditional is added to allow old consumers (native apps, etc) to continue working
// once native stop being hybrid this code can be removed.
if (sessionToken) {
    sessionToken.accountId = sessionToken.username;
    delete sessionToken.username;
}

const role = sessionToken ? roles.PENDING : roles.UNAUTHORISED;

const initialState = sessionToken ? { role, meta: {}, error: null } : {};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.SET_USER_ROLE:
            return {
                ...state,
                role: payload.role,
            };
        case profileTypes.PROFILE_FETCH:
            return {
                ...state,
                role: roles.PENDING,
            };
        case profileTypes.PROFILE_FETCH_SUCCESS:
            return {
                ...state,
                role: getProfileFetchSuccessRole(payload),
            };
        case types.LOGIN_OAUTH_SUBMIT_ERROR:
        case types.LOGIN_OAUTH_AUTHORISE_ERROR:
            return {
                ...state,
                meta: {},
                error: payload ? payload.data : null,
                status: requestStatuses.ERROR,
                role: roles.UNAUTHORISED,
            };
        case types.CLEAR_SESSION:
        case types.TIMEOUT_SUCCESS:
        case types.LOGOUT_SUBMIT:
            return {
                meta: {},
                error: null,
                status: requestStatuses.INITIAL,
            };
        default:
            return state;
    }
};
